import { roundToOneDecimal } from '@/pages/OperationsInsights/utils/roundNumber';
import { addSeconds, DurationUnit, format, formatDuration, intervalToDuration } from 'date-fns';

export function transformDateIntoLocalString(date: string | Date) {
    return format(new Date(date), "yyyy-MM-dd'T'HH:mm:ss'.'SSS");
}

export function transformDateForExport(date: string | Date) {
    return format(new Date(date), 'yyyy-MM-dd-HH-mm-ss');
}

export function calculateDurationInHour(from: string | Date, to: string | Date): number {
    from = new Date(from);
    to = new Date(to);
    const timeDifferenceMs = to.getTime() - from.getTime();
    return roundToOneDecimal(timeDifferenceMs / (1000 * 60 * 60));
}

const durationFields = ['years', 'months', 'weeks', 'days', 'hours', 'minutes', 'seconds'] as DurationUnit[];
export const secondsToTimeRange = (start: Date, seconds: number | undefined, displayPartCount: number) => {
    if (seconds === undefined) return '';
    const duration = intervalToDuration({ start, end: addSeconds(start, seconds) });
    const parts = durationFields
        .map((f) => [f, duration[f]])
        .filter(([_k, v]) => v)
        .slice(0, displayPartCount);

    if (parts.length) {
        const trimmedDuration = Object.fromEntries(parts);
        return formatDuration(trimmedDuration);
    } else {
        const emptyDuration = { seconds: 0 };
        return formatDuration(emptyDuration, { zero: true });
    }
};
